import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as NewbriefCounts from '../../newsbrief-counts'
import * as ContentCalendar from '../types'
import * as Constants from './constants'

export type ToggleModal = Modal.Toggle
export const toggleModal: ToggleModal = Modal.toggleModal(Constants.SEND_EMAIL_FUTURE_DATE)

export const updateEmailAddress = (emailAddress: ContentCalendar.Email) =>
 ({type: Constants.UPDATE_EMAIL_ADDRESS, emailAddress})

export const sendEmail =
 (community: string, data: ContentCalendar.ComponentState, cutoff: string = null, pathname: string) => {
  const sendModeDescription = pathname.slice(1)[0] === 'n' ? Constants.DESIGN_MODE_DESCRIPTION
                                                           : Constants.PREVIEW_MODE_DESCRIPTION
  return (
    Request.requestActionCreator<ContentCalendar.SubmitEmailPayload>(Constants.SEND_EMAIL_FUTURE_DATE)
    ({
      method: 'POST',
      payload: {
        cutoff,
        emails: data.emailString,
        sendModeDescription,
      },
      url:
       `${NewbriefCounts.GENERATE_NEWSBRIEF_RESOURCE}/${community}/date/${data.selectedDate}`,
    })
  )
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/send-email-modal/actions.ts